import { ReactNode } from "react";

interface ButtonProps {
  onClick: () => void;
  variant?: "primary" | "secondary";
  children: ReactNode;
  className?: string;
}

const Button = ({
  onClick,
  variant = "primary",
  children,
  className = ""
}: ButtonProps) => {
  const baseClasses = "sm:ml-3 w-28 font-medium rounded-lg text-sm px-5 py-2.5 text-center";
  
  const variantClasses = {
    primary: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300",
    secondary: "text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100"
  };
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button; 